import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Header from '../Header/Header';
import ListDaily from '../List/Daily';
import ListNcs from '../List/Ncs';
import ListSupervision from '../List/Supervision';
import ListUrgents from '../List/Urgents';
import Main from '../Main/Main';
import Sidebar from '../Sidebar/Sidebar';
import '../Main/style.css';

export default function MainRoute() {
  return (
    <div className="wrapper">
      <BrowserRouter>
        <React.Suspense fallback={<></>}>
          <Header base_url="/gestao" />
          <Sidebar base_url="/gestao" />
          <Routes>
            <Route path="/gestao">
              <Route index element={<ListDaily />} />
              <Route element={<Main />} path={':clientId'} />
              <Route element={<ListNcs />} path="list/ncs" />
              <Route element={<ListUrgents />} path="list/urgents" />
              <Route element={<ListSupervision />} path="list/supervision" />
            </Route>
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    </div>
  );
}
